import React from "react";
import ReactDOM from "react-dom";
import { Route, Routes, BrowserRouter } from "react-router-dom";
import { GlobalContextProvider } from "./contexts/GlobalState";
import App from "./App";
import ToPrint from "./components/Print-Components/toPrint";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import reportWebVitals from "./reportWebVitals";

ReactDOM.render(
    <React.StrictMode>
        <GlobalContextProvider>
            <BrowserRouter>
                <Routes>
                    <Route path='/' exact element={<App />} />
                    <Route path='/print' exact element={<ToPrint />} />
                </Routes>
            </BrowserRouter>
        </GlobalContextProvider>
    </React.StrictMode>,
    document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.register();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
